import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'reverseArray',
    standalone: false,
})
export class ReverseArrayPipe implements PipeTransform {
    public transform = <T>(value: T[]): T[] => value.reverse();
}
